module.exports = __webpack_public_path__ + "img/takeLeave_1_zh.74ed38fb.png";